module.exports = __webpack_public_path__ + "static/media/2-0.7234c5bb.svg";